// extracted by mini-css-extract-plugin
export default {"value":"intl__value___OfcH4","label-value-vertical":"intl__label-value-vertical___Y68N4"};